/** Quantity + material phrase with pluralization (e.g. "2 x Blocks"). */
export function formatQuantityMaterialPhrase(breakItem) {
  const qtyRaw =
    breakItem?.quantity != null && breakItem.quantity !== ''
      ? Number(breakItem.quantity)
      : 1;
  const qty = Number.isFinite(qtyRaw) && qtyRaw > 0 ? qtyRaw : 1;
  const material = pluralizeMaterialLabel(breakItem?.material_type, qty);
  if (!material) return '';
  return `${qty} x ${material}`;
}

/** Yellow course-break title: "Backhand - 2 x Blocks". */
export function formatCourseBreakWeaponTitle(breakItem) {
  const weapon = breakItem?.weapon || '';
  const quantityMaterial = formatQuantityMaterialPhrase(breakItem);
  if (!weapon && !quantityMaterial) return '';
  if (!weapon) return quantityMaterial;
  if (!quantityMaterial) return weapon;
  return `${weapon} - ${quantityMaterial}`;
}

/** Course-break meta line: "Right · Backhand · 2 x Blocks". */
export function formatCourseBreakMetaLine(breakItem) {
  const side =
    breakItem?.side && breakItem.side !== 'N/A' ? breakItem.side : '';
  const weapon = breakItem?.weapon || '';
  const quantityMaterial = formatQuantityMaterialPhrase(breakItem);
  return [side, weapon, quantityMaterial].filter(Boolean).join(' · ');
}

function pluralizeMaterialLabel(materialType, quantity) {
  const raw = String(materialType || '').trim();
  if (!raw) return '';
  const n = Number.isFinite(Number(quantity)) && Number(quantity) > 0 ? Number(quantity) : 1;
  if (n <= 1) return raw;

  const lower = raw.toLowerCase();
  if (lower.endsWith('s')) return raw;

  let plural = raw;
  if (lower.includes('brick')) plural = 'bricks';
  else if (lower.includes('block')) plural = 'blocks';
  else if (lower.includes('tile')) plural = 'tiles';
  else return raw;

  if (raw[0] === raw[0].toUpperCase()) {
    return plural.charAt(0).toUpperCase() + plural.slice(1);
  }
  return plural;
}
